import Button from "../customComponents/Button";
import { useNavigate } from "react-router-dom";

const HotelModal = ({ onClose, hotelData }) => {
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };
  const handleEditClick = () => {
    navigate("/add-hotel", {
      state: {
        hotelinfo: hotelData,
        type: "edit",
        editflag: true,
      },
    });
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-t-lg shadow-lg w-full h-[50vh] md:h-[75vh] overflow-y-auto p-6 border-b mt-auto">
        <div className="flex justify-between items-center mb-6 border-b">
          <h2 className="text-xl font-semibold">Hotel Details</h2>
          <div className="flex space-x-4 items-center">
            <Button
              type="primary"
              label="Edit Property"
              onClick={handleEditClick}
            />
            <a
              onClick={onClose}
              className="text-gray-500 hover:text-black cursor-pointer"
            >
              <span className="material-symbols-outlined">close</span>
            </a>
          </div>
        </div>
        <div className="mt-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 pb-6 border-b">
        {hotelData.hotelName && (
          <div className="mt-7">
            <div className="font-semibold">Hotel Name</div>
            <div className="mt-2">
              <div>{hotelData.hotelName}</div>
            </div>
          </div>
        )}
        {hotelData.roomType && (
          <div className="mt-7">
            <div className="font-semibold">Hotel Type</div>
            <div className="mt-2">
              <div>{hotelData.roomType}</div>
            </div>
          </div>
        )}
        {hotelData.city && (
          <div className="mt-7">
            <div className="font-semibold">City (Destination)</div>
            <div className="mt-2">
              <div>{hotelData.city}</div>
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.accommodationType?.label && (
          <div className="mt-7">
            <div className="font-semibold">Accommodation Type</div>
            <div className="mt-2">
              <div>{hotelData?.hotelwise_plan?.[0]?.accommodationType?.label }</div>
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.grade?.length > 0 && (
          <div className="mt-7">
            <div className="font-semibold">Grade</div>
            <div className="mt-2">
              {hotelData.hotelwise_plan[0].grade.map((g, i) => (
                <div key={i}>{g.label}</div>
              ))}
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.seasonalMonth?.length > 0 && [
            "Deluxe Hotels",
            "3 Star Hotels / Resort Basic",
            "3 star hotels / Resort -Deluxe",
            "4 Star Hotels / Resort Basic",
            "4 Star Hotels / Resort Deluxe",
            "5 Star Hotels"
          ].includes(hotelData?.hoteltype) && (
          <div className="mt-7">
            <div className="font-semibold">Seasonal Month</div>
            <div className="mt-2">
              {hotelData.hotelwise_plan[0].seasonalMonth.map((g, i) => (
                <div key={i}>{g.label}</div>
              ))}
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.seasonsVal &&
          [
            "Deluxe Hotels",
            "3 Star Hotels / Resort Basic",
            "3 star hotels / Resort -Deluxe",
            "4 Star Hotels / Resort Basic",
            "4 Star Hotels / Resort Deluxe",
            "5 Star Hotels"
          ].includes(hotelData?.hoteltype) && (
          <div className="mt-7">
            <div className="font-semibold">Season</div>
            <div className="mt-2">
            {Array.isArray(hotelData.hotelwise_plan[0].seasonsVal) ? (
              hotelData.hotelwise_plan[0].seasonsVal.map((season, idx) => (
                <div key={idx}>{season.label}</div>
              ))
            ) : (
              <div>{hotelData.hotelwise_plan[0].seasonsVal.label}</div>
            )}
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.mealPlan?.label && (
          <div className="mt-7">
            <div className="font-semibold">Meal Plan</div>
            <div className="mt-2">
              <div>{hotelData?.hotelwise_plan?.[0]?.mealPlan?.label }</div>
            </div>
          </div>
        )}
        {hotelData?.hotelwise_plan?.[0]?.weekVal &&
        ![
          "Deluxe Hotels",
          "3 Star Hotels / Resort Basic",
          "3 star hotels / Resort -Deluxe",
          "4 Star Hotels / Resort Basic",
          "4 Star Hotels / Resort Deluxe",
          "5 Star Hotels"
        ].includes(hotelData?.hoteltype) && (
          <div className="mt-7">
            <div className="font-semibold">Week Options</div>
            <div className="mt-2">
              {Array.isArray(hotelData.hotelwise_plan[0].weekVal) ? (
                hotelData.hotelwise_plan[0].weekVal.map((item, i) => (
                  <div key={i}>{item.label}</div>
                ))
              ) : (
                <div>{hotelData.hotelwise_plan[0].weekVal.label}</div>
              )}
            </div>
          </div>
        )}
        {hotelData.price && (
          <div className="mt-7">
            <div className="font-semibold">Price per head (INR)</div>
            <div className="mt-2">
              <div>{hotelData.price}</div>
            </div>
          </div>
        )}
        </div>

        {(() => {
          const raw = hotelData.hotel_image;
          const imgs = Array.isArray(raw) ? raw : (raw ? [raw] : []);
          return imgs.length > 0 ? (
            <div className="mt-6">
              <div className="font-semibold mb-3">Property Images</div>
              <div className="flex flex-wrap gap-3">
                {imgs.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`Property ${i + 1}`}
                    className="w-28 h-28 object-cover rounded-lg border"
                  />
                ))}
              </div>
            </div>
          ) : null;
        })()}

      </div>
    </div>
  );
};

export default HotelModal;
